import DesktopNavigation from "./DesktopNavigation";
import WorkStatus from "./WorkStatus";
import MobileNavigation from "./../../Mobiles/MobileNavigation/MobileNavigation";

const Navigation = () => {
  return (
    <>
      {/* Desktop/Tablet Navigation */}
      <div className="lg:flex md:flex hidden flex-col bg-[#1C1E20] shadow-none mt-20 xl:mt-[29%] 2xl:mt-20 h-[85vh]">
        <div className="flex-1 overflow-y-auto">
          <DesktopNavigation />
        </div>
        <div className="flex-shrink-0">
          <WorkStatus />
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className="lg:hidden md:hidden block">
        <MobileNavigation />
      </div>
    </>
  );
};

export default Navigation;
